<template>
  <div :class="classes" class="locator__place-list">
    <place-info/>

    <google-cluster :markers="googleMarkers" :map="map" :image="clusterImage" @clusterCreated="googleCluster = $event"/>

    <vue-perfect-scrollbar class="scroll-area" :settings="scrollbarSettings" ref="scrollbar">
      <place
        v-for="institution in institutions"
        v-if="institution.institution && institution.institution.lat && institution.institution.lng"
        :key="institution.id"
        :map="map"
        :institutionData="institution"
        @markerCreated="googleMarkers.push($event)"
        ref="places"
      />
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
    import Place from './place'
    import PlaceInfo from './place-info'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'

    export default {
        name: "places-list",
        props: ['map', 'visible'],
        components: {
            Place,
            PlaceInfo,
            VuePerfectScrollbar
        },
        data() {
            return {
                classes: {
                    'visible': this.visible ? this.visible : false
                },
                googleCluster: null,
                googleMarkers: [],
                hiddenMarkers: [],
                scrollbarSettings: {
                    maxScrollbarLength: 60,
                    swipeEasing: false
                }
            }
        },
        watch: {
            visible(newVal) {
                this.classes['visible'] = newVal;
            },
            map(map) {
                map.addListener('zoom_changed', () => {
                    if (!this.googleCluster) return;
                    let zoom = map.getZoom();
                    if (zoom >= 12) {
                        this.googleCluster.setGridSize(1);
                    } else {
                        this.googleCluster.setGridSize(50);
                    }
                })
            },
            institutions: {
                handler() {
                    this.$refs.scrollbar.update();
                },
                deep: true
            }
        },
        computed: {
            institutions() {
                return this.$store.state.institutions;
            },
            clusterImage() {
                if (this.$siteVariantImages[this.$siteVariant] && this.$siteVariantImages[this.$siteVariant]['cluster']) {
                    return this.$siteVariantImages[this.$siteVariant]['cluster'];
                }
                return require('../' + this.$siteAssetDir + '/cluster.svg');
            }
        }
    }
</script>

<style lang="scss">
  .scroll-area {
    position: relative;
    margin: auto;
    width: 100%;
    height: 100%;
    /*overflow-y: scroll;*/
  }

  .d-none {
    visibility: hidden;
    /*display: none;*/
  }

  .ps>.ps__scrollbar-y-rail {
    opacity: 1 !important;
  }
</style>
